interface MarkdownFence {
  character: '`' | '~';
  length: number;
}

const parseRootMarkdownFenceOpening = (line: string): MarkdownFence | null => {
  const match = /^ {0,3}(`{3,}|~{3,})([^\r\n]*)\r?$/.exec(line);
  const marker = match?.[1];
  if (!match || !marker) return null;

  if (marker[0] === '`' && (match[2] ?? '').includes('`')) return null;
  return {
    character: marker[0] as '`' | '~',
    length: marker.length,
  };
};

const isRootMarkdownFenceClosing = (line: string, fence: MarkdownFence): boolean => {
  const match = /^ {0,3}(`{3,}|~{3,})[ \t]*\r?$/.exec(line);
  const marker = match?.[1];
  if (!match || !marker) return false;
  return marker[0] === fence.character && marker.length >= fence.length;
};

export const rewriteOutsideMarkdownFences = (
  text: string,
  rewriteProse: (prose: string, isTrailingProse: boolean) => string,
  rewriteFence: (fence: string) => string = (fence) => fence
): string => {
  let output = '';
  let proseStart = 0;
  let fenceStart = 0;
  let fence: MarkdownFence | null = null;
  let lineStart = 0;

  while (lineStart < text.length) {
    const newline = text.indexOf('\n', lineStart);
    const lineEnd = newline === -1 ? text.length : newline;
    const nextLineStart = newline === -1 ? text.length : newline + 1;
    const line = text.slice(lineStart, lineEnd);

    if (!fence) {
      const opening = parseRootMarkdownFenceOpening(line);
      if (opening) {
        output += rewriteProse(text.slice(proseStart, lineStart), false);
        fenceStart = lineStart;
        fence = opening;
      }
    } else if (isRootMarkdownFenceClosing(line, fence)) {
      output += rewriteFence(text.slice(fenceStart, nextLineStart));
      proseStart = nextLineStart;
      fence = null;
    }

    lineStart = nextLineStart;
  }

  if (fence) return output + rewriteFence(text.slice(fenceStart));
  return output + rewriteProse(text.slice(proseStart), true);
};
